// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React, {Suspense} from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import {nl} from 'yup-locales';
import {setLocale} from 'yup';

// core styles
import "./scss/volt.scss";
import "./scss/customStyle.scss"

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";

import App from "./App";
import {Provider} from 'react-redux';
import store, {persistor} from './store/store';
import {PersistGate} from 'redux-persist/integration/react';
import SpinnerLoading from './admin/layout/components/SpinnerLoading';
import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {createRoot} from "react-dom/client";
import {OpenFeature, OpenFeatureProvider} from '@openfeature/react-sdk';
import Preloader from "./admin/layout/components/Preloader";
import {flagsmithClientProvider} from "./libs/flagsmith";

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["nl", "en"],
    fallbackLng: "nl",
    debug: false,
    // interpolation: ['b'],


    detection: {
      order: ["localStorage", "path", "htmlTag"],
      caches: ["cookie"],
    },

    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
  })
;

i18next.on('languageChanged', function (lng) {
  if (lng === 'nl') {
    setLocale(nl)
  }
});

const container = document.getElementById('root');
const root = createRoot(container);

OpenFeature.setProvider(flagsmithClientProvider);

root.render(
  <Provider store={store}>
    <Suspense fallback={<Preloader/>}>
      <SpinnerLoading>
        <PersistGate loading={null} persistor={persistor}>
          <OpenFeatureProvider>
            <Router>
              <App/>
            </Router>
          </OpenFeatureProvider>
        </PersistGate>
      </SpinnerLoading>
    </Suspense>
  </Provider>
);
